import { useState } from "react";
import { useContextProfileContext } from "src/Contexts/ContextProfile/ContextProfile";
import { useResetInputs } from "src/Contexts/hooks/useResetInputs";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

export const UseFormPasswordUser = () => {
  const { handleGetAlert } = useLayoutMainContext();
  const { valuesUpdatePasswordUser } = useContextProfileContext();
  const { resetInputs } = useResetInputs();

  const [loading, setLoading] = useState(false);

  const resultData = {
    password: valuesUpdatePasswordUser.passwordCurrency || "",
    newPassword: valuesUpdatePasswordUser.passwordNew || "",
    newPassword_repeat: valuesUpdatePasswordUser.newPasswordRepeat || "",
  };

  const handleEdit = () => {
    if (!resultData.password?.trim())
      return handleGetAlert({ message: `Digite uma senha` });

    if (!resultData.newPassword?.trim())
      return handleGetAlert({ message: `Digite uma nova senha` });

    if (!resultData.newPassword_repeat?.trim())
      return handleGetAlert({ message: `Digite a nova senha novamente` });

    setLoading(true);

    return api
      .patch(`registers/password`, resultData)
      .then((res) => {
        handleGetAlert({ message: res.data.message });
        resetInputs();
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  return { handleSubmit: handleEdit, loading };
};
